import { Box, Chip, Typography } from "@mui/material";
import EscoDataGrid from "../../Controls/EscoGrid/EscoDataGrid";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";
import { forceService, getMicroserviciosList } from "../../../Service/microservicioService";

function ConfigMicroserviciosDataView(props) {
    const [data, setData] = useState([]);

    const { accessToken } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const { tokenExpiration, getAccessToken } = useContext(AuthContext);    

    const navigate = useNavigate();

    const handleMore = (row) => {
        navigate("params", {
            state: {
                CodServicio: row.CodServicio,
                CodInterfaz: row.CodInterfazServ,
                DescInterfaz: row.DescInterfaz,
            },
        });
    };

    const handleEjec = (row) => {
        forceService( accessToken, {forceService_Request :
            { CodServicio: row.CodServicio, 
                CodInterfazServ: row.CodInterfazServ }});
    };

    const habdleForce = (row) => {        
        // switch (row.PuedeForzar) {
        // case 1:
        //     return true;
        // case 0:
        //     return false;
        // default:
        //     return false;
        // }
    };
    /*
    useEffect(() => { 
        setData(serviciosData);
    }, []);
    */

    useEffect(() => {
        init();        
    }, [])

    const init = () => {
        getAccessToken()
            .then((token) => {
                setLoading(true);
                getMicroserviciosList(token)
                    .then((data) => {
                        setData(data);
                        setLoading(false)
                    })
                    .catch()
                    .finally(() => setLoading(false))

            })
    } 


    const columns = [
        { field: "DescServicio", headerName: "Servicio", width: 400,autoHeight: true, flex: 1},
        { field: "DescInterfaz", headerName: "Interfaz", width: 700, autoHeight: true, flex: 1 },
        {
            field: "Estado",
            headerName: "Estado",
            width: 100,
            renderCell: (params) => {
                const estado = params.value;

                // Verifica si el Estado es -1
                if (estado === -1) {
                    // Renderiza un chip o cualquier otro componente que desees
                    return <Chip label="Activo" color="success" />;
                }

                // En caso contrario, solo muestra el valor del Estado
                return <span></span>;
            },
            autoHeight: true,
            //flex: 1
        },
        { field: "Frecuencia", headerName: "Frecuencia", width: 500, autoHeight: true, flex: 1},
    ];

    const rows = data;

    function getRowId(row) {
        return row.CodServicio + "-" + row.CodInterfazServ;
    }

    return (
        <div sx={{ height: 600, width: "100%" }}>
            <Typography variant="button" sx={{ fontSize: 14, color: "gray" }}>
                Microservicios
            </Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pNavegar={true}
                pHandleMore={handleMore}
                pHandleEjec={handleEjec}
                pAgregar={false}
                pInit={habdleForce}
            />
        </div>
    );
}

export default ConfigMicroserviciosDataView;
